import React, { useState } from "react";
import {
  Link,
  NavLink,
  useNavigate,
} from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";
import Logo from "../../assets/logo.png";

const Header = () => {
  const { user, logout } = useAuth();
  const { lang, setAlbanian, setEnglish } = useLanguage();

  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState("");

  const menuLabels = {
    en: {
      home: "Home",
      shop: "Shop",
      repair: "Repair",
      parts: "Electronic Parts",
      service: "IT Services",
      contact: "Contact",
      slogan: "Technology. Solutions. Trust.",
    
    },

    sq: {
      home: "Kryefaqja",
      shop: "Dyqani",
      repair: "Riparime",
      parts: "Komponente Elektronike",
      service: "Shërbime IT",
      contact: "Kontakti",
      slogan: "Teknologji. Zgjidhje. Besim.",
      
    },
  };

  const labels = lang === "sq" ? menuLabels.sq : menuLabels.en;

  const menuItems = [
    {
      path: "/",
      label: labels.home,
    },
    {
      path: "/shop",
      label: labels.shop,
    },
    {
      path: "/repair",
      label: labels.repair,
    },
    {
      path: "/parts",
      label: labels.parts,
    },
    {
      path: "/service",
      label: labels.service,
    },
    {
      path: "/contact",
      label: labels.contact,
    },
  ];

  const handleLogout = () => {
    logout();
    setMobileMenuOpen(false);
    navigate("/login");
  };

  const handleMobileLink = () => {
    setMobileMenuOpen(false);
  };


const handleSubmit = (e) => {
  e.preventDefault();

  if (!search.trim()) return;

  navigate(`/search?q=${encodeURIComponent(search)}`);

  setShowSearch(false);
};
  

  const desktopLinkClass = ({ isActive }) =>
    `
      relative py-4 text-[13px] font-bold uppercase tracking-[0.03em]
      transition-colors duration-300
      ${
        isActive
          ? "text-blue-600"
          : "text-slate-800 hover:text-blue-600"
      }
      
      after:absolute
      after:left-0
      after:bottom-3
      after:h-[2px]
      after:bg-blue-600
      after:transition-all
      after:duration-300
      
      ${
        isActive
          ? "after:w-full"
          : "after:w-0 hover:after:w-full"
      }
    `;

const mobileLinkClass = ({ isActive }) =>
  `
    relative
    block
    w-full
    border-b
    border-slate-100
    px-1
    py-4
    text-left
    text-[13px]
    font-bold
    uppercase
    tracking-[0.03em]
    transition-colors
    duration-300

    ${
      isActive
        ? "text-blue-600"
        : "text-slate-800 hover:text-blue-600"
    }

    after:absolute
    after:bottom-0
    after:left-0
    after:h-[2px]
    after:bg-blue-600
    after:transition-all
    after:duration-300

    ${
      isActive
        ? "after:w-10"
        : "after:w-0 hover:after:w-10"
    }
  `;

  return (
    <header className="sticky top-0 z-[1000] border-b border-slate-100 bg-white/95 shadow-[0_4px_20px_rgba(15,23,42,0.06)] backdrop-blur-xl">
      <div className="mx-auto flex h-[46px] max-w-[1440px] items-center justify-between px-3 sm:px-4 lg:px-5">
        {/* Logo */}
        <Link
          to="/"
          className="flex shrink-0 items-center gap-3"
          aria-label="Master Sol&TECH"
        >
          <img
            src={Logo}
            alt="Master Sol&TECH"
            className="h-11 w-auto object-contain sm:h-9"
          />

          <div className="hidden flex-col leading-none sm:flex">
            <span className="text-[19px] font-extrabold tracking-tight text-slate-900">
              MASTER{" "}
              <span className="text-blue-600">
                SOL&TECH
              </span>
            </span>

            <span className="mt-1 text-[9px] font-semibold uppercase tracking-[0.16em] text-slate-500">
             {labels.slogan}
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
<nav className="hidden items-center gap-5 xl:flex">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={desktopLinkClass}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden items-center gap-3 xl:flex">


        {showSearch && (
          <div
            className="
              absolute
              left-0
              top-full
              w-full
              bg-white
              border-t
              shadow-lg
              z-50
            "
          >
            <form
              onSubmit={handleSubmit}
              className="mx-auto flex max-w-6xl justify-center px-6 py-3"
            >
              <input
                autoFocus
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={
                  lang === "sq"
                    ? "Kërko produkte, pjesë, riparime..."
                    : "Search products, parts, repairs..."
                }
                className="
                  w-full
                  max-w-2xl
                  rounded-full
                  border
                  border-slate-300
                  bg-slate-50
                  px-5
                  py-2.5
                  text-sm
                  outline-none
                  transition
                  focus:border-blue-500
                  focus:bg-white
                  focus:ring-2
                  focus:ring-blue-100
                "
              />
            </form>
          </div>
        )}

          {/* Search */}
            <button
          onClick={() => setShowSearch(!showSearch)}
          className="flex h-8 w-8 items-center justify-center rounded-full transition hover:bg-blue-50"
      >
          <i className={`fas ${showSearch ? "fa-times" : "fa-search"}`}></i>
      </button>


          {/* Language */}
          <div className="ml-1 flex items-center rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
            <button
              type="button"
              onClick={setAlbanian}
              aria-label="Shqip"
              className={`rounded-lg px-2 py-1 text-sm font-bold transition ${
                lang === "sq"
                  ? "bg-blue-600 text-white"
                  : "text-slate-600 hover:bg-blue-50"
              }`}
            >
              SQ
            </button>

            <button
              type="button"
              onClick={setEnglish}
              aria-label="English"
              className={`rounded-lg px-2 py-1 text-sm font-bold transition ${
                lang === "en"
                  ? "bg-blue-600 text-white"
                  : "text-slate-600 hover:bg-blue-50"
              }`}
            >
              EN
            </button>
          </div>

          {/* Authentication */}
         
        </div>

        {/* Mobile Actions */}
        <div className="flex items-center gap-2 xl:hidden">
         {/* Mobile Search */}
  <button
    type="button"
    onClick={() => {
      setShowSearch((current) => !current);
      setMobileMenuOpen(false);
    }}
    aria-label={
      showSearch
        ? lang === "sq"
          ? "Mbyll kërkimin"
          : "Close search"
        : lang === "sq"
        ? "Hap kërkimin"
        : "Open search"
    }
    aria-expanded={showSearch}
    className="
      flex
      h-10
      w-10
      items-center
      justify-center
      rounded-full
      border
      border-slate-200
      bg-white
      text-slate-800
      shadow-sm
      transition
      hover:border-blue-300
      hover:bg-blue-50
      hover:text-blue-600
    "
  >
    <i
      className={`fas ${
        showSearch ? "fa-times" : "fa-search"
      }`}
    />
  </button>

{/* Mobile Search Bar */}
{showSearch && (
  <div
    className="
      border-t
      border-slate-100
      bg-white
      shadow-lg
      lg:hidden
    "
  >
    <form
      onSubmit={handleSubmit}
      className="mx-auto flex max-w-[1440px] px-4 py-3 sm:px-6"
    >
      <div className="relative w-full">
        <i
          className="
            fas
            fa-search
            pointer-events-none
            absolute
            left-4
            top-1/2
            -translate-y-1/2
            text-sm
            text-slate-400
          "
        />

        <input
          autoFocus
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={
            lang === "sq"
              ? "Kërko produkte, pjesë, riparime..."
              : "Search products, parts, repairs..."
          }
          className="
            w-full
            rounded-full
            border
            border-slate-300
            bg-slate-50
            py-2.5
            pl-11
            pr-4
            text-sm
            text-slate-800
            outline-none
            transition
            placeholder:text-slate-400
            focus:border-blue-500
            focus:bg-white
            focus:ring-2
            focus:ring-blue-100
          "
        />
      </div>
    </form>
  </div>
)}


          <button
            type="button"
            aria-label={
              mobileMenuOpen
                ? "Close mobile menu"
                : "Open mobile menu"
            }
            aria-expanded={mobileMenuOpen}
            onClick={() =>
              setMobileMenuOpen((current) => !current)
            }
            className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-200 bg-white text-xl text-slate-900 shadow-sm transition hover:border-blue-300 hover:text-blue-600"
          >
            <i
              className={
                mobileMenuOpen
                  ? "fas fa-times"
                  : "fas fa-bars"
              }
            ></i>
          </button>
        </div>
      </div>



      {/* Mobile Menu */}
        <div
        className={`overflow-hidden border-t border-slate-100 bg-white transition-all duration-300 xl:hidden ${
          mobileMenuOpen
            ? "max-h-[1366px] opacity-100"
            : "max-h-0 border-t-0 opacity-0"
        }`}
      >
        <div className="mx-auto max-w-[1440px] px-5 py-3 sm:px-6">
        <nav className="flex flex-col">
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                onClick={handleMobileLink}
                className={mobileLinkClass}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="mt-5 border-t border-slate-100 pt-5">

            {/* Mobile Language */}
         <div className="mb-4 flex items-center justify-between">
  <span className="text-[11px] font-bold uppercase tracking-[0.08em] text-slate-500">
    {lang === "sq" ? "Gjuha" : "Language"}
  </span>

  <div className="flex items-center rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
    <button
      type="button"
      onClick={setAlbanian}
      aria-label="Shqip"
      className={`rounded-lg px-3 py-1.5 text-sm font-bold transition ${
        lang === "sq"
          ? "bg-blue-600 text-white"
          : "text-slate-600 hover:bg-blue-50"
      }`}
    >
      SQ
    </button>

    <button
      type="button"
      onClick={setEnglish}
      aria-label="English"
      className={`rounded-lg px-3 py-1.5 text-sm font-bold transition ${
        lang === "en"
          ? "bg-blue-600 text-white"
          : "text-slate-600 hover:bg-blue-50"
      }`}
    >
      EN
    </button>
  </div>
</div>

         
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;